export function typify(data) {
    return (() => data)();
}
//# sourceMappingURL=utils.js.map